module.exports = __webpack_public_path__ + "img/Footer-Twitter.a1332f5.svg";